<div
  class="ot_card_border"
  [ngClass]="{
    clos: isOtClos,
    conduite: ot.typeOT === TypeOt.Conduite,
    depannage: ot.typeOT === TypeOt.Depannage,
    correctif: ot.typeOT === TypeOt.Correctif,
    preventif: ot.typeOT === TypeOt.Preventif,
    permanence: ot.typeOT === TypeOt.Permanence,
    travaux: ot.typeOT === TypeOt.Travaux,
    gestion: ot.typeOT === TypeOT.Gestion,
    autres: ot.typeOT === TypeOt.Autres,
  }"
></div>

<ion-card
  [button]="true"
  class="card"
  #otCard
  [ngClass]="{
    clos: isOtClos,
    conduite: ot.typeOT === TypeOt.Conduite,
    depannage: ot.typeOT === TypeOt.Depannage,
    correctif: ot.typeOT === TypeOt.Correctif,
    preventif: ot.typeOT === TypeOt.Preventif,
    permanence: ot.typeOT === TypeOt.Permanence,
    travaux: ot.typeOT === TypeOt.Travaux,
    gestion: ot.typeOT === TypeOT.Gestion,
    autres: ot.typeOT === TypeOt.Autres,
  }"
  (click)="interactWithOT()"
>
  <div class="infos-container">
    <section>
      <p class="libelle-ot">{{ ot.libelle }}</p>
      <p class="libelle-site">{{ descriptionSite }}</p>
      <div *ngIf="ot.affichageDetails">
        <p *ngIf="ot.installations && ot.installations.length > 0" class="libelle-installation">
          {{ ot.installations[0].description }}
        </p>
        <p *ngIf="ot?.demandeIntervention?.commentaire_client" class="commentaire" [class.wrap_initial]="!isInDayGrid">
          <u><b>Commentaire client :</b></u>
          &nbsp;{{ ot.demandeIntervention.commentaire_client }}
        </p>
        <p
          *ngIf="ot?.demandeIntervention?.commentaire_planificateur || ot?.demandeIntervention?.commentaire_interne"
          class="commentaire"
          [class.wrap_initial]="!isInDayGrid"
        >
          <u><b>Commentaire interne :</b></u>
          &nbsp;
          {{
            ot.demandeIntervention.commentaire_planificateur
              ? ot.demandeIntervention.commentaire_planificateur
              : ot.demandeIntervention.commentaire_interne
          }}
        </p>
      </div>
      <div *ngIf="displayLabelsCompact" class="labels-container">
        <div *ngFor="let label of labels">{{ label }}</div>
      </div>
    </section>
    <div *ngIf="displayIconsLabels && !displayLabelsCompact">
      <div class="icons-container">
        <ion-icon color="medium" *ngFor="let icon of icons" [name]="icon"></ion-icon>
      </div>
      <div class="labels-container">
        <div *ngFor="let label of labels">{{ label }}</div>
      </div>
    </div>
  </div>
</ion-card>
<ng-container *ngIf="!isInDayGrid">
  <p class="dateDebut">{{ ot.dateDebut | date: 'HH:mm' }}</p>
  <p class="dateFin">{{ ot.dateFin | date: 'HH:mm' }}</p>
  <p *ngIf="nbrOtsSite > 1" class="compteurOt" translate>
    Sur ce site il y a
    <strong translate>{{ nbrOtsSite }} OT planifiés</strong>
    ce jour
  </p>
</ng-container>
